import "./InspectionAndReport.module.css";
import Header from "@/reusable_sections/Header";
import Diagnostica from "./sections/Diagnostica";
import Report from "./sections/Report";
import Footer from "@/reusable_sections/Footer";
export default function InspectionAndReportPage() {
  return <div>
      <Header />
      <Diagnostica />
      <Report />
      <Footer />
    </div>;
}